import reduxCreator from '../libs/mk-womanizer/redux-creator';
import axiosPlugin from "../libs/mk-womanizer/ac-axios-plugin";


let redux = reduxCreator.type('USER_PASSWORD').plugin(axiosPlugin);

let updateUserPasswordAction = redux.fetchActionCreate();

export const updateUserPassword = (userId, data = {}) => updateUserPasswordAction(`/users/${userId}/change-password`);

export const userPassword = redux.reducer();